var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addHexPrefix } from "../utils";
export const DEFAULT_STABLE_CONFIRMATIONS = 6;
export class DefaultBTCRelayAPI {
    constructor(api) {
        this.api = api;
    }
    getStableBitcoinConfirmations() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.query.btcRelay.stableBitcoinConfirmations().then((param) => param.toNumber());
        });
    }
    getStableParachainConfirmations() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.query.btcRelay.stableParachainConfirmations().then((param) => param.toNumber());
        });
    }
    getLatestBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.query.btcRelay.bestBlock();
        });
    }
    getLatestBlockHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.api.query.btcRelay.bestBlockHeight()).toNumber();
        });
    }
    isBlockInRelay(blockHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = yield this.api.query.btcRelay.blockHeaders(addHexPrefix(blockHash));
            return !value.isEmpty;
        });
    }
}
//# sourceMappingURL=btc-relay.js.map